export default function ContentContainer(props: {
  children: JSX.Element | JSX.Element[];
}) {
  return (
    <div className="relative flex w-0 flex-1 flex-col overflow-hidden">
      {props.children}
    </div>
  );
}
